<div *ngIf="!(reportDownloadService.isExporting$ | async)">
  <shared-dropdown-generic
    [options]="exportOptions"
    [buttonClass]="buttonClass"
    [buttonText]="buttonText"
    [buttonIcon]="buttonIcon"
    [disabled]="disabled"
    [size]="size"
    [tooltipText]="tooltipText"
    [dropdownId]="dropdownId"
    (optionSelected)="onExportSelected($event)"
  />
</div>

<div
  *ngIf="reportDownloadService.isExporting$ | async"
  class="align-items-center justify-content-center"
>
  <i class="fa fa-spin fa-spinner fs-2"></i>
</div>
